const SORT_DIRECTION_MAPPER = {
  ascend: "asc",
  descend: "desc",
};

const getSortParam = (sorter) => {
  if ((sorter?.columnKey || sorter?.field) && sorter?.order) {
    return {
      sort: {
        [sorter.columnKey || sorter.field]:
          SORT_DIRECTION_MAPPER[sorter.order] ?? "asc",
      },
    };
  }
  return {};
};

export default getSortParam;
